<div class="container-comentario">
  <section class="title-container">
  </section>
  <div style="width: 100%; padding:1.2vh;">

    <h3 *ngIf="!salvo && _professor.tipo != 1">{{ 'questionario.comentarios.tituloProfessor' | translate }}</h3>
    <h3 *ngIf="!salvo && _professor.tipo == 1">Deseja fazer um comentário sobre a avaliação para {{_professor.nome}}</h3>
    <div class="comment-section">
      <div *ngIf="!salvo">

        <textarea #myTextArea style="width: 100%;" maxlength="4000" placeholder="Escreva o comentário aqui..." 
          (input)="change($event.target.value)">{{comentarioProfessor}}</textarea>
        <span *ngIf="comentarioProfessor?.length < 3999">
          {{ 4000 - comentarioProfessor?.length }}
          *
          {{ 'questionario.comentarios.caracteres' | translate }}
        </span>

        <span *ngIf="comentarioProfessor?.length >= 3999">
          {{ 4000 - comentarioProfessor?.length }}
          *
          {{ 'questionario.comentarios.caracter' | translate }}
        </span>
      </div>

      <!--
      <app-feedback *ngIf="salvo" message="questionario.comentarios.sucesso">
      </app-feedback>

      <div *ngIf="!reavaliado" class="btn-container">
        <div class="cancelar">
          <button class="cancelar-button" (click)="cancelar()">
            <strong>
              {{ 'Cancelar' }}
            </strong>
          </button>
        </div>
        <app-button (click)="salvar()">
          <strong>
            {{ 'Salvar avaliação' }}
          </strong>
        </app-button>
      </div>

      <div class="col-xs-12 jump" *ngIf="reavaliado" (click)="salvar()" style="cursor: pointer; display: flex; -webkit-box-align: center; align-items: center; color: #007bc2; margin-left: auto; margin-right: auto; margin-top: 25px;">
        <i class="far fa-check" style="font-size: 3vh; margin-right: 10px;"></i>
        <a style="margin-right: 8px;">{{'questionario.questoes.finalizarreavaliacao'| translate}}</a>
      </div>
      -->
    </div>
  </div>
</div>
